import { useState } from "react";
import { LifeBuoy, Mail, Send, Phone } from "lucide-react";
import { toast } from "sonner";
import { api } from "../lib/leuteliaApi";

const FAQ = [
  ["Quanto spesso si aggiornano i dati?", "LEUTELIA rilegge il sito e le fonti esterne a ogni scansione; la Panoramica mostra sempre la data dell'ultima lettura."],
  ["Un modulo ha il lucchetto: perché?", "Non è compreso nel tuo pacchetto. Cliccandolo vedi cosa include il pacchetto superiore e puoi richiederlo con un clic; trovi il confronto completo nella pagina Pacchetti."],
  ["A chi consegno il lavoro?", "In Direzione & Reparti ogni intervento è già assegnato al reparto competente: basta condividere la pagina o il Report in PDF."],
];

export default function Aiuto({ user }) {
  const [form, setForm] = useState({ subject: "", message: "", phone: "" });
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try { await api.aiutoContatto(form); setSent(true); toast.success("Messaggio inviato: ti risponderemo al più presto."); }
    catch (err) { toast.error(err.message || "Invio non riuscito"); } finally { setBusy(false); }
  };
  const input = "w-full rounded-lg border border-brand-gold/30 bg-white px-3 py-2.5 text-[14px] text-brand-ink placeholder:text-brand-ink/40 focus:outline-none focus:ring-2 focus:ring-brand-gold/40";
  return (
    <div className="relative z-10 px-4 sm:px-8 py-7 max-w-[1320px] leu-in" data-testid="pagina-aiuto">
      <div className="text-brand-orange font-bold tracking-[0.22em] text-[11px] uppercase mb-3">Aiuto</div>
      <h1 className="font-serif text-3xl md:text-4xl text-brand-ink">Come possiamo aiutarti?</h1>
      <p className="mt-2 text-[14px] text-brand-ink/70 max-w-3xl leading-relaxed">Scrivici.<br />Il messaggio arriva direttamente all'amministrazione di LEUTELIA.<br />Ti risponderemo al più presto.</p>
      <div className="mt-6 grid gap-6 lg:grid-cols-[1fr_380px]">
        <form onSubmit={submit} className="bg-white rounded-xl border border-brand-gold/25 p-5" data-testid="aiuto-form">
          <div className="flex items-start gap-3 mb-4"><LifeBuoy size={20} className="text-brand-gold mt-0.5" />
            <div><h2 className="font-serif text-[20px] text-brand-ink leading-none">Scrivi all'assistenza</h2>
              <p className="text-[12.5px] text-brand-ink/60 mt-1.5">Domande sull'uso, sui dati, sui pacchetti o segnalazioni di errori.</p></div></div>
          {sent ? (
            <div className="rounded-lg bg-brand-green/10 text-brand-green p-4 text-[14px]" data-testid="aiuto-inviato">Grazie, messaggio ricevuto. Ti risponderemo al più presto a <b>{user?.email}</b>.</div>
          ) : (
            <div className="space-y-3">
              <input className={input} placeholder="Oggetto" value={form.subject} onChange={set("subject")} required minLength={3} data-testid="aiuto-oggetto" />
              <textarea className={`${input} min-h-[160px]`} placeholder="Descrivi la richiesta: più dettagli ci dai, più precisa sarà la risposta." value={form.message} onChange={set("message")} required minLength={10} data-testid="aiuto-messaggio" />
              <input className={input} placeholder="Telefono (facoltativo, se preferisci essere richiamato)" value={form.phone} onChange={set("phone")} data-testid="aiuto-telefono" />
              <button type="submit" disabled={busy} className="inline-flex items-center gap-2 rounded-full bg-brand-green text-brand-cream px-5 py-2.5 text-[13.5px] font-semibold hover:brightness-110 disabled:opacity-60" data-testid="aiuto-invia"><Send size={15} /> {busy ? "Invio…" : "Invia il messaggio"}</button>
            </div>
          )}
        </form>
        <div className="space-y-4">
          <div className="bg-white rounded-xl border border-brand-gold/25 p-5" data-testid="aiuto-contatti">
            <h3 className="font-serif text-[18px] text-brand-ink">Contatti diretti</h3>
            <a href="mailto:info@leutelia.it" className="mt-3 flex items-center gap-2 text-[14px] text-brand-green hover:underline" data-testid="aiuto-email-link"><Mail size={15} /> info@leutelia.it</a>
            <div className="mt-2 flex items-center gap-2 text-[12.5px] text-brand-ink/60"><Phone size={14} /> Lascia il telefono nel modulo e ti richiamiamo noi.</div>
          </div>
          <div className="bg-white rounded-xl border border-brand-gold/25 p-5">
            <h3 className="font-serif text-[18px] text-brand-ink">Domande frequenti</h3>
            <dl className="mt-3 space-y-3">
              {FAQ.map(([q, a]) => <div key={q}><dt className="text-[13.5px] font-semibold text-brand-ink">{q}</dt><dd className="text-[12.5px] text-brand-ink/65 leading-relaxed mt-0.5">{a}</dd></div>)}
            </dl>
          </div>
        </div>
      </div>
    </div>
  );
}
